import React from "react";
import PropTypes from "prop-types";
import NavIcon from "./NavIcon";
import styles from "./NavIcons.module.css";
import { getNavIcon, getNavPartProps } from "../navigationBarBrandRefreshClasses";

const legacyRewardsIcon = require("./imgs/Rewards.svg");
const brandRefreshRewardsIcon = require("./imgs/brand-refresh-Rewards.svg");

const RewardsIcon = ({ onClick }) => {
  const rewardsIcon = getNavIcon(legacyRewardsIcon, brandRefreshRewardsIcon);

  return (
    <NavIcon onClick={onClick} ariaLabel="Rewards">
      <img
        src={rewardsIcon}
        alt=""
        className={styles.rewardsIcon}
        data-part={getNavPartProps("rewards-icon")}
      />
    </NavIcon>
  );
};

RewardsIcon.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default RewardsIcon;
